import { Button, Group, Loader, Stack, Title } from '@mantine/core';
import moment from 'moment';
import { useState } from 'react';

import { DatePickerInput } from '@components';
import { BATCHES_ARCHIVE_MONTHS } from '@constants';
import { useGenerateBatchesReport } from '@hooks/declaration';

interface BatchesArchivedReportProps {
  title: string;
}

export const BatchesArchivedReport: React.FC<BatchesArchivedReportProps> = ({ title }) => {
  const [date, setDate] = useState(moment().subtract(BATCHES_ARCHIVE_MONTHS, 'months').toDate());
  const generateBatchesReportMutation = useGenerateBatchesReport();
  const isLoading = generateBatchesReportMutation.isPending;

  const handleDownloadReport = () => {
    generateBatchesReportMutation.mutate({ date });
  };

  return (
    <Stack gap="xl">
      <Title order={2}>{title}</Title>

      <DatePickerInput
        label="Unarchive from date (older than 2 months)"
        value={date}
        onChange={(value: Date) => setDate(value)}
        clearable={true}
        maxDate={moment().subtract(BATCHES_ARCHIVE_MONTHS, 'months').toDate()}
      />

      <Group>
        <Button leftSection={isLoading && <Loader color="#FFFFFF" />} onClick={handleDownloadReport} disabled={isLoading} variant="filled" size="lg">
          {isLoading ? 'Generating report..' : 'Generate report'}
        </Button>
      </Group>
    </Stack>
  );
};
